module.exports = __webpack_public_path__ + "img/40_58.227c4b20.png";